import React, { useState } from 'react';
import GeneralSettings from './Parent/General';
import FormQualification from './Parent/Qualification'; // Fix the import statement
import FormCustomFields from './Parent/CustomFields'; // Add import for Custom Fields
import { Card, Col, Container, Row, ListGroup } from 'react-bootstrap';
import BreadCrumb from 'Common/BreadCrumb';

const Settings = () => {
  document.title = 'Settings | CITY SERVICE';

  const [activeTab, setActiveTab] = useState('General'); // State untuk melacak tab aktif

  const renderContent = () => {
    switch (activeTab) {
      case 'General':
        return <GeneralSettings />;
      case 'Qualification': // Add case for Qualification
        return <FormQualification />;
      case 'Custom Fields': // Add case for Custom Fields
        return <FormCustomFields />;
      default:
        return <p>Settings content goes here.</p>;
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb pageTitle="Settings" title="Settings Recruitments" />

          <Row>
            <Col lg={2}>
              <ListGroup>
                <ListGroup.Item
                  className={`list-group-item-action ${activeTab === 'General' ? 'active' : ''}`}
                  action
                  onClick={() => setActiveTab('General')}
                >
                  <i className="ri-reply-fill align-middle me-2"></i>General
                </ListGroup.Item>
                <ListGroup.Item
                  className={`list-group-item-action ${activeTab === 'Custom Fields' ? 'active' : ''}`}
                  action
                  onClick={() => setActiveTab('Custom Fields')}
                >
                  <i className="ri-share-forward-fill align-middle me-2"></i>Custom Field's
                </ListGroup.Item>
                <ListGroup.Item
                  className={`list-group-item-action ${activeTab === 'Qualification' ? 'active' : ''}`}
                  action
                  onClick={() => setActiveTab('Qualification')}
                >
                  <i className="ri-equalizer-line align-middle me-2"></i>Qualification
                </ListGroup.Item>
                <ListGroup.Item
                  className={`list-group-item-action ${activeTab === 'Minimum Score' ? 'active' : ''}`}
                  action
                  onClick={() => setActiveTab('Minimum Score')}
                >
                  <i className="ri-delete-bin-5-line align-middle me-2"></i>Minimum Score
                </ListGroup.Item>
                <ListGroup.Item
                  className={`list-group-item-action ${activeTab === 'Additional Settings' ? 'active' : ''}`}
                  action
                  onClick={() => setActiveTab('Additional Settings')}
                >
                  <i className="ri-forbid-line align-middle me-2"></i>Additional Settings
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col lg={10}>
              <Card>
                <Card.Header className='p-3' style={{ backgroundColor: '#181a21', color: '#fff' }}>
                  <h5 className="card-title mb-0">{activeTab} Settings</h5>
                </Card.Header>
                <Card.Body>
                  {renderContent()}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Settings;
